import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import wordpress from "../../Assets/Projects/wordpress.png"
import inilah from "../../Assets/Projects/inilah.png"
import javabica from "../../Assets/Projects/javabica.png"
import parsepoint from "../../Assets/Projects/parsepoint.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wordpress}
              isBlog={false}
              title="Chatify (WordPress, Supabase)"
              description="I developed the website JMJhomes.com.au, created for a construction company based in Sydney, Australia. Unlike other projects where I used Lovable and Supabase, this one was fully built with WordPress, customizing the theme and structure to reflect the company’s brand identity. I focused on delivering a professional, responsive, and easy-to-navigate platform."
              // ghLink="https://github.com/novasiliver/Chatify"
              demoLink="https://JMJhomes.com.au/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={inilah}
              isBlog={false}
              title="Inilah (Laravel, PHP React, Next.js, API Integration)"
              description="Inicom is the first media innovation in Indonesia that carries the concept of solutions journalism. Apart from presenting curated news and content that focuses on problem-solving, ini.com is also a platform that allows its users to publish news and content as well as play an active role in solving problems that are currently being discussed by the public. Ini.com connects its readers with journalists, content creators, communities, government, business, and academics to help solve various problems in society."
              // ghLink="https://github.com/novasiliver/Chatify"
              demoLink="https://www.inilah.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={javabica}
              isBlog={false}
              title="Javabica (Laravel, PHP Vue.js, Nuxt.js, API Integration)"
              description="Javabica is Indonesia's leading B2B coffee supplier. We supply to over 200 hotels across all major brands--Marriott, Intercontinental Hotel Group, Accor, and more. We're also the leading supplier for cafe chains. What makes Javabica unique is not simply the quality of our beans and their affordability, but that we work across our entire ecosystem to ensure sustainable practices."
              // ghLink="https://github.com/novasiliver/Chatify"
              demoLink="https://javabica.com/"
            />
          </Col>
        </Row>
                <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={parsepoint}
              isBlog={false}
              title="ParsePoint (Next.js, React, Django, Stripe, Amazon S3)"
              description="ParsePoint is a web platform for uploading and analyzing utility bills using OCR. I led development using React, Next.js, Django, and AWS. Features include file/folder management (S3), role-based access, Stripe-powered subscriptions, and visual dashboards. It’s built for individuals and enterprises managing utility data across multiple facilities."
              // ghLink="https://github.com/novasiliver/Chatify"
              demoLink="https://parsepoint.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
